import { CarregaService } from '../services/carrega_file/carrega.service';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { ApiService } from '../services/contratos/contratos.service';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';

@Component({
    selector: 'app-planilha-input-diretos-lcb',
    templateUrl: './planilha-input-diretos-lcb.component.html',
    styleUrls: ['./planilha-input-diretos-lcb.component.css'],
    standalone: false
})

export class PlanilhaInputDiretosLcbComponent {

  item: any = {};
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlConsultaTrips: string = 'https://qu0d5gqb4g.execute-api.sa-east-1.amazonaws.com/v1/';
  queryDiretasPlanilha: string = 'Viagens-Diretas-Planilha';
  query2: string = 'Carriers';
  query3: string = 'Locais_Karrara_Transport';
  queryVeiculos: string = 'veiculos_lab_Karrara';
  queryTimeTable: string = 'janelasTimeTable';
  dataLoaded = false;
  jsonData: any;
  sortColumn: string = '';
  sortDirection: number = 1;
  startDate!: Date;
  endDate: Date = new Date();
  dialogOpen!: boolean;
  isLoading: boolean = true;
  programacaoDiretas: any[] = [];
  tabelaDia: boolean = false;
  clickedButtons: { [key: string]: boolean } = {};
  diaSelect: string = '';
  programacaoDiretasFiltradas!: any[];
  totalMU: number = 0;
  totalFornecedores: number = 0;
  currentTime!: Date;
  isButtonDisabled: boolean = true;
  diaSemana!: string;
  diaSemanaOntem!: string;
  isButtonDisabledHoje: boolean = true;
  usuarioLogado: any;
  selectedDate: Date = new Date();

  constructor(
    private carregaService: CarregaService,
    private http: HttpClient,
    private dynamodbService: ApiService,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private autenticacaoService: AutenticacaoService
  ) { }

  async ngOnInit() {
    await this.initializeVariablesWithCurrentDay();
    await this.upDate();
    this.checkTime();
    setInterval(() => {
      this.checkTime();
    }, 300000);
  }

  initializeVariablesWithCurrentDay(): void {
    const today = new Date();
    const currentDayOfWeek = today.getDay(); // 0 (Domingo) a 6 (Sábado)
    const dayKey = this.getDayKey(currentDayOfWeek);

    // Inicializa os botões, setando true para o dia atual
    this.clickedButtons = {
      'seg': false,
      'ter': false,
      'qua': false,
      'qui': false,
      'sex': false
    };

    if (dayKey) {
      this.clickedButtons[dayKey] = true;
      this.diaSelect = dayKey; // Inicializa diaSelect com o dia atual
    }
  }

  getDayKey(dayIndex: number): string {
    switch (dayIndex) {
      case 1: return 'seg';
      case 2: return 'ter';
      case 3: return 'qua';
      case 4: return 'qui';
      case 5: return 'sex';
      default: return ''; // Não faz nada no final de semana
    }
  }

  async upDate() {
    await this.getUserLogado();
    await this.getProgramacaoDiretasFromDynamoDB();
    await this.somaMU();
    this.isLoading = false;
  }

  checkTime() {
    this.currentTime = new Date();
    const diasDaSemana = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'];
    this.diaSemana = diasDaSemana[this.currentTime.getDay()];
    const currentDayIndex = this.currentTime.getDay();
    const previousDayIndex = (currentDayIndex === 0) ? 6 : currentDayIndex + 1;
    this.diaSemanaOntem = diasDaSemana[previousDayIndex];
    const today15 = new Date(this.currentTime);
    today15.setHours(15, 30, 0, 0);
    const tomorrow15 = new Date(today15);
    tomorrow15.setDate(today15.getDate() + 1);
    // Verifica se a hora atual está entre 15:00 do dia atual e 15:00 do próximo dia
    this.isButtonDisabled = this.currentTime >= today15 && this.currentTime < tomorrow15 && this.diaSelect == this.diaSemanaOntem && this.usuarioLogado.role != 9;
    this.isButtonDisabledHoje = (this.diaSelect == this.diaSemana || this.currentTime > this.selectedDate) && this.usuarioLogado.role != 9;
  }

  somaMU() {
    this.totalMU = 0;
    this.totalFornecedores = 0;
    if (this.programacaoDiretasFiltradas) {
      this.programacaoDiretasFiltradas.forEach(item => {
        this.totalMU += parseFloat(item.quantidadeMU)
      })
      this.totalFornecedores = this.programacaoDiretasFiltradas.length
    }
  }

  async getUserLogado() {
    //console.log("logado")
    // //console.log(this.autenticacaoService?.obterUsuarioLogado())
    this.usuarioLogado = await this.autenticacaoService.obterUsuarioLogado();
    //console.log(this.usuarioLogado)
  }

  async abrirTabela(dia: string) {
    this.onDayClick(dia);
    Object.keys(this.clickedButtons).forEach(key => {
      if (key !== dia) {
        this.clickedButtons[key] = false;
      }
    });
    this.diaSelect = dia;
    this.checkTime();
    this.clickedButtons[dia] = !this.clickedButtons[dia];
    this.programacaoDiretasFiltradas = await this.programacaoDiretas.filter(item => {
      return (item.diaSemana == this.diaSelect);
    });
    await this.somaMU();
    // console.log(`Propriedade ${dia} foi definida como:`, this.clickedButtons[dia]);
  }

  // Função que trata o clique no botão, passando o dia da semana
  onDayClick(day: string): void {
    const today = new Date();
    const currentDayOfWeek = today.getDay(); // 0 (Domingo) a 6 (Sábado)
    const targetDayOfWeek = this.getDayOfWeek(day); // Função para pegar o número do dia (1=Seg, 2=Ter,...)  
    let daysToAdd: number;
    // Caso especial para quando for segunda-feira e o usuário clicar em sexta-feira
    if (currentDayOfWeek === 1 && targetDayOfWeek === 5) {
      // Segunda-feira (currentDayOfWeek === 1) e clicou em Sexta-feira (targetDayOfWeek === 5)
      daysToAdd = -3; // Mostra a última sexta-feira (3 dias atrás de segunda-feira)
    } else {
      // Para todos os outros casos
      daysToAdd = this.calculateDaysToAdd(currentDayOfWeek, targetDayOfWeek);
    }
    const targetDate = new Date(today);
    targetDate.setDate(today.getDate() + daysToAdd);
    this.selectedDate = targetDate; // Data da ocorrência do dia clicado
  }

  // Função que mapeia o nome do dia para o número correspondente (1 = Segunda, ..., 5 = Sexta)
  getDayOfWeek(day: string): number {
    switch (day) {
      case 'seg': return 1; // Segunda-feira
      case 'ter': return 2; // Terça-feira
      case 'qua': return 3; // Quarta-feira
      case 'qui': return 4; // Quinta-feira
      case 'sex': return 5; // Sexta-feira
      default: return 0; // Caso seja um dia inválido
    }
  }

  // Função que calcula quantos dias adicionar para o próximo dia da semana
  calculateDaysToAdd(currentDayOfWeek: number, targetDayOfWeek: number): number {
    // Ajustando currentDayOfWeek para 1 a 7 (1=Segunda, ..., 7=Domingo)
    currentDayOfWeek = currentDayOfWeek === 0 ? 7 : currentDayOfWeek; // Converte domingo (0) para 7
    targetDayOfWeek = targetDayOfWeek === 0 ? 7 : targetDayOfWeek;
    if ((targetDayOfWeek + 1) >= currentDayOfWeek) {
      return targetDayOfWeek - currentDayOfWeek; // O dia é mais tarde na semana
    } else {
      return 7 - (currentDayOfWeek - targetDayOfWeek); // O dia já passou, pegue a próxima semana
    }
  }

  inserirNova() {
    this.item = {};
    const dataAtual = new Date();
    this.item.ID = dataAtual.getTime().toString();
    // console.log(this.item)
    this.dialogOpen = true;
  }

  editDialog(item: any): void {
    if (!this.isButtonDisabled || this.usuarioLogado.role != 9) {
      this.item = { ...item }
      // console.log(item)
      this.dialogOpen = true;
    } else { }
  }

  adicionarContato() {
    this.item.contatos.push({ nome: '', telefone: '', email: '' });
  }

  removerContato(index: number) {
    this.item.contatos.splice(index, 1);
  }

  async salvar2(item: any) {
    this.isLoading = true;
    this.item = { ...item };
    this.item.tableName = this.queryDiretasPlanilha;
    this.item.origemDiretoLCB = true
    this.item.diaSemana = this.diaSelect;
    this.item.Janela = this.selectedDate.toISOString();
    // console.log(this.item); // Verifique a estrutura antes de enviar
    // Certifique-se de que os contatos estão sendo preservados
    // if (!this.item.contatos || !Array.isArray(this.item.contatos)) {
    //   console.error('Contatos não estão presentes ou não são um array.');
    //   this.isLoading = false;
    //   return;
    // }
    // console.log([this.item])
    try {
      await this.dynamodbService.salvar([this.item], this.queryDiretasPlanilha, this.urlAtualiza).subscribe(async response => {
        await this.upDate();
        await this.salvarNaTimeTable();
        this.dialogOpen = false;
        this.isLoading = false;
      }, error => {
        console.log(error);
        this.isLoading = false;
      });
    } catch (error) {
      console.log(error);
      this.isLoading = false;
    } 
  }

  cancel(): void {
    this.dialogOpen = false;
  }

  async getProgramacaoDiretasFromDynamoDB(): Promise<void> {
    const lambdaEvent = {
      "tableName": this.queryDiretasPlanilha,
      "searchConditions": [
        // { "column": "status", "word": "Completed", "negate": true },
        // { "column": "status", "word": "Canceled", "negate": true },
        // { "column": "Finalizada", "word": "true", "negate": true },
        // { "column": "Finalizada", "word": "True", "negate": true },
        // { "column": "ID", "word": "", "negate": true }
      ]
    };
    const response: any = await new Promise(async (resolve, reject) => {
      (await this.dynamodbService.getItemsFiltroColuna(lambdaEvent, this.urlConsultaTrips, 'filtro')).subscribe(
        (res: any) => resolve(res),
        (error: any) => reject(error)
      );
    });
    if (response.statusCode == 200) {
      try {
        const items = await JSON.parse(response.body);
        if (Array.isArray(items)) {
          if (this.usuarioLogado.role == 4) {
            this.programacaoDiretas = items.filter(item => {
              return (item.fornecedor == this.usuarioLogado.company)
            })
          } else {
            this.programacaoDiretas = items;
          }
          this.programacaoDiretasFiltradas = this.programacaoDiretas.filter(item => {
            return (item.diaSemana == this.diaSelect);
          });

        } else {
          console.error('Invalid items data:', items);
        }
      } catch (error) {
        console.error('Error parsing JSON:', error);
      }
    } else {
      console.error('Invalid response:', response);
    }
  }

  async salvarNaTimeTable() {
    this.isLoading = true;
    // console.log(this.item)
    let horaJanela = this.item.horario;
    const datePart = this.item.Janela.split('T')[0];
    const dataHoraString = `${datePart}T${this.item.horario}:00.000Z`;
    const dataHora = new Date(dataHoraString);
    const formattedDate = dataHora.toISOString();
    const currentDate = new Date().getTime();

    this.item = {
      ...this.item,
      "ID": this.item.ID,
      "lastUpdate": new Date(),
      "dataJanelaTimeTable": datePart,
      "dataJanela": datePart,
      "horaJanelaTimeTable": horaJanela,
      "JanelaDestino 1": formattedDate,
      // "Janela": formattedDate,
      // "jan1": formattedDate,
      "Plate": this.item.placa,
      "Volumes": this.item.quantidadeMU,
      'Fornecedor 1': this.item.fornecedor,
      'Fornecedores': this.item.fornecedor,
      "tableName": this.queryTimeTable,
      "Transportadora": "DIRETO",
      'area': 'RECSIDER',
      'Destino 1': 'LCB'
    }
    console.log(this.item)
    const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);
    // Converter a string JSON para um objeto JavaScript
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    // console.log(jsonArray)
    await this.dynamodbService.salvar(jsonArray, this.queryTimeTable, this.urlAtualiza).subscribe(async response => {
      // console.log(response)
      await this.upDate();
      this.dialogOpen = false;
      this.isLoading = false;
    }, error => {
      console.log(error);
      this.isLoading = false;
    });
  }

  // async deleteItem(Item: any): Promise<void> {
  //   // const companyUsuarioLogado = this.usuarioLogado.company?.toLowerCase();
  //   // const transportadoraItem = Item.Transportadora.toLowerCase();
  //   // console.log(Item)
  //   // // console.log(this.usuarioLogado.company)
  //   // if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && transportadoraItem.includes(companyUsuarioLogado) && Item.area == "EMB")) {
  //   const confirmacao = window.confirm("Tem certeza que deseja excluir este registro?");
  //   // Verifica se o usuário confirmou a ação
  //   if (confirmacao) {
  //     this.isLoading = true;
  //     const ID = Item.ID;
  //     // console.log(ID)
  //     // console.log(Item.tableName)
  //     await this.dynamodbService.deleteItem(ID, this.urlAtualiza, Item.tableName).subscribe(
  //       async response => {
  //         await this.upDate();
  //         this.dialogOpen = false;
  //         this.isLoading = false;
  //       },
  //       error => {
  //         console.log(error)
  //         // Lógica para lidar com erros durante a deleção do item
  //       }
  //     );
  //   }

  async deleteItem(item: any) {
    const confirmacao = window.confirm("Tem certeza que deseja excluir este registro?");
    //   // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;
      this.item.tableName = this.queryDiretasPlanilha;
      this.item = {
        ...item,
        "lastUpdate": new Date(),
        "placa": "",
        "quantidadeMU": '0'
      }
      // console.log([this.item])
      try {
        await this.dynamodbService.salvar([this.item], this.queryDiretasPlanilha, this.urlAtualiza).subscribe(async response => {
          await this.upDate();
          this.dialogOpen = false;
          await this.deleteItemTimeTable(item.ID);
          this.isLoading = false;
        }, error => {
          console.log(error);
          this.isLoading = false;
        });
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    }
  }

  async deleteItemDB(ID: string): Promise < void> {
    const confirmacao = window.confirm("Tem certeza que deseja excluir este registro?");
    //   // Verifica se o usuário confirmou a ação
    if (confirmacao) {
    await this.dynamodbService.deleteItem(ID, this.urlAtualiza, this.queryDiretasPlanilha).subscribe(
      async response => {
        await this.upDate();
      },
      error => {
      }
    );
  }
  }

  async deleteItemTimeTable(ID: string): Promise<void> {
    const confirmacao = window.confirm("Tem certeza que deseja excluir este registro?");
    if (confirmacao) {
      this.isLoading = true;
      await this.dynamodbService.deleteItem(ID, this.urlAtualiza, this.queryTimeTable).subscribe(
        async response => {
          console.log("Deletado da Time Table")
        },
        error => {
          // Lógica para lidar com erros durante a deleção do item
        }
      );
    }
  }



  // } else {
  //   const confirmacao = window.confirm("Usuário não autorizado!");
  //   // Verifica se o usuário confirmou a ação
  //   if (confirmacao) {
  //     this.dialogOpen = false;
  //   }
  // }
  // }
}
